import { Typography } from "@mui/material";
import { PrimaryInfoAlert } from "react-common-ui-library";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import {
  BUTTON,
  FIND_PROVIDER_URL,
  LINK_APPLICATION_ROUTE,
  PROVIDER_CONTACT_NUMBER,
  SEARCH_HAP_ID_ROUTE,
  TARGET_BLANK,
} from "../../../Constants/CommonConstants";
import {
  LINK_APPLICATION_ALERT_TEXT,
  LINK_APPLICATION_PROVIDER_SEARCH_LINK,
  LINK_APPLICATION_SEARCH_HEADING,
  LINK_APPLICATION_SEARCH_LINK,
  LINK_MY_APPLICATION_ALERT,
  LINK_MY_APPLICATION_ALERT_CONTENT,
} from "../../../Constants/LinkMyApplicationConstants";
import { clearSearchHapId } from "../../../Features/LinkApplicationSlice";
import ConfigService from "../../../Services/ConfigService";
import EndpointService from "../../../Services/EndpointService";
import { StyledInlineLink } from "../../../Styles/Common/CommonStyles";
import { useDispatch } from "react-redux";

const providerContactNumber = ConfigService(PROVIDER_CONTACT_NUMBER);

/**
 * @description Utilizes PrimaryInfoAlert component to show the banner alert.
 * @returns {ReactNode} Alert component shown on the LinkMyApplication component
 */
const LinkMyApplicationAlert = () => {
  const intl = useIntl();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const searchForYourHapIdClickHandler = () => {
    dispatch(clearSearchHapId());
    navigate(`/${LINK_APPLICATION_ROUTE}/${SEARCH_HAP_ID_ROUTE}`);
  };

  return (
    <PrimaryInfoAlert
      id={LINK_MY_APPLICATION_ALERT}
      title={intl.formatMessage({
        id: LINK_APPLICATION_SEARCH_HEADING,
      })}
      content={
        <Typography id={LINK_MY_APPLICATION_ALERT_CONTENT}>
          {intl.formatMessage(
            { id: LINK_APPLICATION_ALERT_TEXT },
            {
              hapIdSearchLink: (
                <StyledInlineLink
                  id={LINK_APPLICATION_SEARCH_LINK}
                  component={BUTTON}
                  type={BUTTON}
                  onClick={searchForYourHapIdClickHandler}
                >
                  {intl.formatMessage({ id: LINK_APPLICATION_SEARCH_LINK })}
                </StyledInlineLink>
              ),
              providerSearchLink: (
                <StyledInlineLink
                  id={LINK_APPLICATION_PROVIDER_SEARCH_LINK}
                  href={EndpointService(FIND_PROVIDER_URL)}
                  aria-label={`${intl.formatMessage({
                    id: LINK_APPLICATION_PROVIDER_SEARCH_LINK,
                  })}`}
                  target={TARGET_BLANK}
                >
                  {intl.formatMessage({
                    id: LINK_APPLICATION_PROVIDER_SEARCH_LINK,
                  })}
                </StyledInlineLink>
              ),
              providerContactNumber: providerContactNumber,
            }
          )}
        </Typography>
      }
    />
  );
};

export default LinkMyApplicationAlert;
